import styled from 'styled-components'
import { ButtonVariant } from './types'

const ToolbarContainer = styled.div`
  min-height: 64px;
  background: white;
  border-bottom: 1px solid #e1e5e9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 768px) {
    padding: 12px;
    min-height: auto;
  }
`

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    gap: 8px;
    flex: 1;
  }
`

const CenterSection = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;

  @media (max-width: 768px) {
    display: none;
  }
`

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 8px;
  }

  @media (max-width: 480px) {
    width: 100%;
    justify-content: space-between;
  }
`

const BackButton = styled.button`
  padding: 8px 12px;
  background: none;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  color: #656d76;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;

  @media (max-width: 768px) {
    padding: 6px 10px;
    font-size: 13px;
  }

  &:hover {
    background: #f6f8fa;
    border-color: #bdc6cf;
  }

  &:active {
    background: #f1f3f6;
  }
`

const MapTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: #24292f;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;

  @media (max-width: 768px) {
    font-size: 16px;
    max-width: 150px;
  }
`

const SaveStatus = styled.span<{ $hasChanges: boolean }>`
  font-size: 14px;
  color: ${props => (props.$hasChanges ? '#fb8500' : '#656d76')};
  font-weight: ${props => (props.$hasChanges ? '500' : '400')};

  @media (max-width: 768px) {
    font-size: 12px;
  }

  @media (max-width: 480px) {
    display: none;
  }
`

const Button = styled.button<{ $variant?: ButtonVariant }>`
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 13px;
  }

  ${props =>
    props.$variant === 'primary'
      ? `
    background: #2da44e;
    color: white;
    border: 1px solid #2da44e;
    
    &:hover {
      background: #2c974b;
      border-color: #2c974b;
    }
    
    &:active {
      background: #298e46;
    }
  `
      : `
    background: white;
    color: #24292f;
    border: 1px solid #d0d7de;
    
    &:hover {
      background: #f6f8fa;
      border-color: #bdc6cf;
    }
    
    &:active {
      background: #f1f3f6;
    }
  `}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

const Divider = styled.div`
  width: 1px;
  height: 24px;
  background: #d0d7de;

  @media (max-width: 768px) {
    display: none;
  }
`

export {
  ToolbarContainer,
  LeftSection,
  CenterSection,
  RightSection,
  BackButton,
  MapTitle,
  SaveStatus,
  Button,
  Divider,
}
